import { render, staticRenderFns } from "./UserAttestation.vue?vue&type=template&id=59512420&"
import script from "./UserAttestation.vue?vue&type=script&lang=js&"
export * from "./UserAttestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports